angular.module('tf.controllers')
    .controller('NavigationController', ['$scope','items','HeaderService','$rootScope','ConversionService', 'Session',
            function ($scope, items, HeaderService, $rootScope, ConversionService, Session) {

                Session.whenReady().then(() =>{
                    if(Session.farm.settings.custom_messages && Session.farm.settings.custom_messages.no_templates){
                        document.getElementById('customMessage').innerHTML =
                        marked.parse(Session.farm.settings.custom_messages.no_templates);
                        $scope.customMessage = true;
                    }
                });

                $scope.items = items.content? items : _.chain(items)
                    .each(function(item){
                        if(item.cluster && item.cluster_name && item.name.indexOf("@") > -1){

                            item.name = item.name.replace((item.name.substr(item.name.indexOf("@")+1, item.name.length).trim()), item.cluster_name);
                        }
                    })
                    .groupBy(function(item){
                        if(item.sharing_user){
                            return item.id;
                        }
                        return item.cluster || item.fid;
                    })
                    .map(_.sample)
                    .value();

                if(items.breadcrumbs && items.breadcrumbs.length > 0){
                    HeaderService.setName(items.breadcrumbs[items.breadcrumbs.length-1].name);
                } else {
                    var headerName = "Template Farm";
                    if(Session && Session.farm && Session.farm.name){
                        headerName = Session.farm.name;
                    }
                    HeaderService.setName(headerName);
                }

                HeaderService.setLogo(items.logo);
                $scope.imageApiStatus = Session.farm.plan.image_editor;
                //ConversionService.listen($scope, items);
    }])
;
